import { Component } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService, PriceCalculationService, ProgressBarService
} from '../expert-service-call.index';
@Component({
	selector: 'expert-upholstery-options',
	templateUrl: './expert-upholstery.template.html',
	styleUrls: ['./expert-upholstery.component.css'],
})
export class ExpertUpholsteryOptions {
	public upholsteryOptions = [];
	public upholsteryKeyValues: String[] = [];
	public expUpholstery: Data[] = [];
	public selected: Data[] = [];
	public retained = [];
	public expertUpholsteryOptions: any;
	public subscription: Subscription;
	constructor(private dataLoaderService: DataLoaderService, private resetService: ResetService,
		private priceCalculationService: PriceCalculationService, private progressService: ProgressBarService) {
		this.upholsteryOptions = this.dataLoaderService.data.upholstery;
	}
	ngOnInit() {
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalUpholstery") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					if(!this.dataLoaderService.flagDictionary.undoActivatedForUpholstery){
						this.dataLoaderService.previousUpholsteryExp = selectedOption.data[0].code;
					}
				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForUpholstery){
						this.dataLoaderService.previousUpholsteryExp = [];
					}
				}
				this.progressService.progressBarValidation();
			}
		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertUpholstery") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					this.dataLoaderService.previousUpholsteryExp = selectedOption.data[0].code;
				} else {
					this.selected = [];
					this.dataLoaderService.previousUpholsteryExp = [];
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForUpholstery= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load	
		let upholstery;
		this.upholsteryOptions.forEach(element => {
			if (element.selected === true) {
				upholstery = element;
				this.dataLoaderService.previousExpertUpholstery = upholstery;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [upholstery] });
			}
		});

		//Reset
		this.subscription = this.resetService.notifyObservable$.subscribe(() => {
			this.selected = this.resetService.expUpholstery;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: this.resetService.expUpholstery });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: this.resetService.expUpholstery });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}
	ngAfterContentChecked() {
		this.upholsteryKeyValues = [];

		for (let index = 0; index < this.upholsteryOptions.length; index++) {
			if (this.upholsteryOptions[index].selected === false) {
				this.upholsteryKeyValues.push(((this.upholsteryOptions[index].code + " - " + this.upholsteryOptions[index].description)));
			}

		}


		for (let j = 0; j < this.upholsteryKeyValues.length; j++) {
			if (this.selected != undefined) {
				for (let i = 0; i < this.selected.length; i++) {

					let item = this.upholsteryKeyValues[j].substring(0, this.upholsteryKeyValues[j].indexOf(' - '));
					let temp = this.selected[i] + "";
					if (item === temp) {

						this.upholsteryKeyValues.splice(Number(j), 1);
					}
				}
			}
		}
	}

	clearOptions() {
		this.expertUpholsteryOptions = null;
	}

	// adds selected upholstery	
	onUpholsteryOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForUpholstery= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
		// if (this.dataLoaderService.previousExpertUpholstery.length>0) {
		// 	this.dataLoaderService.expertRemovedCodes.push(this.dataLoaderService.previousExpertUpholstery[0]);
		// }
		// this.dataLoaderService.previousExpertUpholstery = [];
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let upholsteryCode;
		upholsteryCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(upholsteryCode);
		this.selected = item;
		this.dataLoaderService.flagDictionary.expertValidateFlag = true;
		this.dataLoaderService.flagDictionary.expertvalidated = false;
		for (let i in this.upholsteryOptions) {
			if (this.upholsteryOptions[i].code === upholsteryCode) {
				this.expUpholstery = this.upholsteryOptions[i];
				// this.dataLoaderService.previousExpertUpholstery = this.upholsteryOptions[i];
				this.upholsteryOptions[i].selected = true;
			}
			else {
				this.upholsteryOptions[i].selected = false;
			}
		}
		// For expert added codes
		// for (let i in this.upholsteryOptions) {
		// 	for (let j in this.dataLoaderService.expAdd){
		// 		if (item != this.dataLoaderService.previousUpholsteryExp 
		// 			&& this.upholsteryOptions[i].code == this.dataLoaderService.expAdd[j] 
		// 			&& !this.upholsteryOptions[i].selected) {
		// 				this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 		if(this.dataLoaderService.expAdd[j]==this.dataLoaderService.previousUpholsteryExp){
		// 			this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 	}
		// }
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.expUpholstery] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.expUpholstery] });
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
	}



	//removes selected upholstery
	deleteSelExpUpholstery(item) {
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let upholsteryCode;
		upholsteryCode = item.substr(0, 3);
		this.selected = [];
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: this.selected });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: this.selected });
		let selcFacForRem = [];
		for (let k in this.upholsteryOptions) {
			if (this.upholsteryOptions[k].selected) {
				selcFacForRem.push(this.upholsteryOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertUpholstery", data: [selcFacForRem] });
		for (let i in this.upholsteryOptions) {
			if (this.upholsteryOptions[i].code === upholsteryCode) {
				this.dataLoaderService.expertRemovedCodes.push(this.upholsteryOptions[i]);
				this.upholsteryOptions[i].selected = false;
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				//this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
	}

}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery.component.ts